<div *ngIf="topBarAnnouncements[activeTopBarIndex] as announcement"
  class="store-announcement-bar" [attr.aria-label]="'Komunikat sklepu' | translate" aria-live="polite">
  <div class="store-announcement-inner">
    <span class="store-announcement-message notranslate" translate="no">{{ announcement.text }}</span>
    <div *ngIf="topBarAnnouncements.length > 1" class="store-announcement-controls"
      [attr.aria-label]="'Nawigacja komunikatów' | translate">
      <button type="button" [attr.aria-label]="'Poprzedni komunikat' | translate" (click)="showPreviousTopBarAnnouncement()">
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="m5 12 5-5 5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <button type="button" [attr.aria-label]="'Następny komunikat' | translate" (click)="showNextTopBarAnnouncement()">
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="m5 8 5 5 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</div>

<nav class="w-full bg-white shadow-custom backdrop-blur-xl">
  <!-- Desktop Navigation -->
  <div class="hidden lg:block desktop-nav">
    <div class="nav-main-row flex items-center justify-between">
      <div class="nav-section flex items-center gap-4">
        <app-logo [size]="'desktop'" class=""></app-logo>
      </div>

      <div class="search-container">
        <app-search-input class="w-full"></app-search-input>
      </div>

      <div class="nav-actions">
        <!-- Country/Currency Selector -->
        <div class="country-selector-container">
          <button (click)="onCountryButtonClick($event)"
            class="group relative flex h-11 w-11 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
            [ngClass]="{ 'bg-gray-100 text-orange-600': isCountrySelectorOpen }"
            [attr.aria-label]="'Wybierz kraj i walutę' | translate"
            [attr.aria-expanded]="isCountrySelectorOpen"
            type="button">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="h-[22px] w-[22px]">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12h19.5" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 2.25v19.5" />
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3s-4.5 4.03-4.5 9 2.015 9 4.5 9z" />
            </svg>
            <span
              class="absolute -right-1 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-white bg-orange-500 px-1 text-[9px] font-bold leading-none text-white notranslate"
              translate="no">
              {{ currentLanguageBadge }}
            </span>
          </button>
        </div>

        <a class="nav-compare-button" routerLink="/products/compare"
          [attr.aria-label]="'Porównaj produkty, wybrano: ' + comparisonCount"
          [title]="'Porównaj produkty' | translate">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M12 3v3m0 0 7 3m-7-3L5 9m7-3v14m-6 0h12M5 9l-3 7h6L5 9zm14 0-3 7h6l-3-7z" />
          </svg>
          <span *ngIf="comparisonCount > 0" class="nav-compare-count">{{ comparisonCount }}</span>
        </a>

        <div class="action-buttons-container">
          <app-action-buttons></app-action-buttons>
          <app-cart-button [isOpen]="isCartOpen" (toggle)="toggleCart()">
          </app-cart-button>
        </div>
      </div>
    </div>
    <div class="nav-category-actions">
      <app-menu-toggle [isOpen]="isDrawerOpen && selectedDesktopMenuAction === 'CATEGORIES'"
        (toggle)="onDesktopMenuAction('CATEGORIES')" [controlsId]="'mega-menu'"
        [showLabel]="true" [flatStyle]="true" class="transition-smooth">
      </app-menu-toggle>
      <span class="nav-category-divider" aria-hidden="true"></span>
      <button type="button" class="desktop-collection-trigger sale-trigger"
        [class.is-active]="isDrawerOpen && selectedDesktopMenuAction === 'SALE'"
        [attr.aria-expanded]="isDrawerOpen && selectedDesktopMenuAction === 'SALE'"
        aria-controls="mega-menu" (click)="onDesktopMenuAction('SALE')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <circle cx="7.5" cy="7.5" r="2" stroke-width="1.8" />
          <circle cx="16.5" cy="16.5" r="2" stroke-width="1.8" />
          <path stroke-linecap="round" stroke-width="1.8" d="m18 5-12 14" />
        </svg>
        {{ 'Promocje' | translate }}
      </button>
      <button type="button" class="desktop-collection-trigger new-trigger"
        [class.is-active]="isDrawerOpen && selectedDesktopMenuAction === 'NEW'"
        [attr.aria-expanded]="isDrawerOpen && selectedDesktopMenuAction === 'NEW'"
        aria-controls="mega-menu" (click)="onDesktopMenuAction('NEW')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="m12 3 1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2L12 3Z" />
          <path stroke-linecap="round" stroke-width="1.8"
            d="m19 14 .9 2.1L22 17l-2.1.9L19 20l-.9-2.1L16 17l2.1-.9L19 14Z" />
        </svg>
        {{ 'Nowości' | translate }}
      </button>
      <button type="button" class="manufacturers-trigger" (click)="openManufacturersModal()"
        [attr.aria-expanded]="isManufacturersModalOpen" aria-controls="manufacturers-modal">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="M3 21V8l6 3V8l6 3V4h6v17H3Z" />
          <path stroke-linecap="round" stroke-width="1.8"
            d="M7 15h2m3 0h2m3 0h2m-12 3h2m3 0h2m3 0h2" />
        </svg>
        {{ 'Producenci' | translate }}
      </button>
    </div>
  </div>
  <!-- Mobile Navigation -->
  <div class="mobile-nav flex items-center justify-between px-4 py-3 lg:hidden bg-white border-b border-gray-100">
    <!-- Menu Toggle -->
    <div class="flex items-center flex-shrink-0">
      <app-menu-toggle [isOpen]="isDrawerOpen" (toggle)="toggleDrawer()" [controlsId]="'mobile-menu'"
        [showLabel]="false" class="transition-smooth">
      </app-menu-toggle>
    </div>

    <!-- Logo - Centered and bigger on mobile -->
    <div class="flex-1 flex justify-center items-center px-2">
      <div class="logo-container transition-transform duration-300">
        <app-logo [size]="'mobile'" class="hover-scale max-w-full"></app-logo>
      </div>
    </div>

    <!-- Compact utility actions -->
    <div class="mobile-actions flex shrink-0 items-center gap-0.5">
      <div class="country-selector-container">
        <button type="button" (click)="onCountryButtonClick($event)"
          class="group relative flex h-11 w-11 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
          [ngClass]="{ 'bg-gray-100 text-orange-600': isCountrySelectorOpen }"
          [attr.aria-label]="'Wybierz kraj i walutę' | translate" [attr.aria-expanded]="isCountrySelectorOpen">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="h-[22px] w-[22px]" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12h19.5" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 2.25v19.5" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3s-4.5 4.03-4.5 9 2.015 9 4.5 9z" />
          </svg>
          <span
            class="absolute -right-1 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-white bg-orange-500 px-1 text-[9px] font-bold leading-none text-white notranslate"
            translate="no">
            {{ currentLanguageBadge }}
          </span>
        </button>
      </div>
      <a class="nav-compare-button" routerLink="/products/compare"
        [attr.aria-label]="'Porównaj produkty, wybrano: ' + comparisonCount"
        [title]="'Porównaj produkty' | translate">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="M12 3v3m0 0 7 3m-7-3L5 9m7-3v14m-6 0h12M5 9l-3 7h6L5 9zm14 0-3 7h6l-3-7z" />
        </svg>
        <span *ngIf="comparisonCount > 0" class="nav-compare-count">{{ comparisonCount }}</span>
      </a>
      <app-action-buttons></app-action-buttons>
      <app-cart-button [isOpen]="isCartOpen" (toggle)="toggleCart()"></app-cart-button>
    </div>
  </div>

</nav>

<div *ngIf="isManufacturersModalMounted" class="manufacturers-modal-backdrop"
  [class.is-open]="isManufacturersModalOpen"
  (click)="closeManufacturersModal()" role="presentation">
  <section id="manufacturers-modal" class="manufacturers-modal" role="dialog" aria-modal="true"
    [attr.aria-hidden]="!isManufacturersModalOpen"
    aria-labelledby="manufacturers-modal-title" (click)="$event.stopPropagation()">
    <header class="manufacturers-modal-header">
      <div>
        <h2 id="manufacturers-modal-title">{{ 'Producenci i dostawcy A–Z' | translate }}</h2>
        <p>{{ 'Pełna lista firm przypisanych do grup produktów.' | translate }}</p>
      </div>
      <button type="button" class="manufacturers-modal-close" [attr.aria-label]="'Zamknij listę producentów' | translate"
        (click)="closeManufacturersModal()">{{ '×' | translate }}</button>
    </header>

    <div class="manufacturers-modal-content">
      <div class="manufacturer-filters">
        <label class="manufacturer-search">
          <span class="sr-only">{{ 'Szukaj producentów' | translate }}</span>
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"></circle>
            <path d="m16 16 4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
          </svg>
          <input type="search" [(ngModel)]="manufacturerSearchTerm"
            [placeholder]="'Szukaj producentów' | translate" autocomplete="off" />
          <button *ngIf="manufacturerSearchTerm" type="button" [attr.aria-label]="'Wyczyść wyszukiwanie producentów' | translate"
            (click)="manufacturerSearchTerm = ''">{{ '×' | translate }}</button>
        </label>

        <nav class="manufacturer-letters notranslate" [attr.aria-label]="'Filtruj producentów według pierwszej litery' | translate" translate="no">
          <button *ngFor="let letter of manufacturerLetters"
            type="button" translate="no" [class.active]="selectedManufacturerLetter === letter"
            (click)="selectedManufacturerLetter = letter">{{ letter }}</button>
        </nav>
      </div>

      <p *ngIf="isLoadingManufacturers" class="manufacturer-list-state">{{ 'Ładowanie listy producentów…' | translate }}</p>
      <p *ngIf="!isLoadingManufacturers && manufacturers.length === 0" class="manufacturer-list-state">
        {{ 'Brak dostępnych producentów.' | translate }}
      </p>
      <div *ngIf="!isLoadingManufacturers && manufacturers.length > 0 && filteredManufacturers.length > 0"
        class="manufacturer-list">
        <button *ngFor="let manufacturer of filteredManufacturers"
          type="button" class="manufacturer-list-item notranslate" translate="no"
          (click)="selectManufacturer(manufacturer)">
          {{ manufacturer }}
        </button>
      </div>
      <p *ngIf="!isLoadingManufacturers && manufacturers.length > 0 && filteredManufacturers.length === 0"
        class="manufacturer-list-state">
        {{ manufacturerEmptyStateMessage }}
      </p>
    </div>
  </section>
</div>

<!-- Dropdown components -->
<app-mega-menu [isDrawerOpen]="isDrawerOpen" [currentUser]="currentUser" [isUserLoggedIn]="isLoggedIn()"
  [selectedCountry]="selectedCountry" [menuSelection]="selectedDesktopMenuAction"
  (close)="closeDrawer()" (profileClick)="navigateToProfile()"
  (countryClick)="onCountryButtonClick($event)" id="mega-menu" class="transition-smooth">
</app-mega-menu>

<!-- Mobile Search Overlay -->
<div *ngIf="isMobileSearchOpen" class="mobile-search-overlay fixed inset-0 z-50 bg-white"
  [class.safe-area-inset]="true">
  <!-- Header -->
  <div class="sticky top-0 z-10 flex items-center gap-3 p-4 border-b border-gray-200 bg-white/95 backdrop-blur-sm">
    <button (click)="toggleMobileSearch()"
      class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors touch-target"
      [attr.aria-label]="'Zamknij wyszukiwanie' | translate">
      <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <h2 class="text-base sm:text-lg font-semibold text-gray-900 navbar-enhanced-font">{{ 'Wyszukaj produkty' | translate }}</h2>
  </div>

  <!-- Search Input -->
  <div class="p-4 bg-gray-50/50">
    <div
      class="relative flex items-center bg-white rounded-2xl border border-gray-200 focus-within:border-orange-500 focus-within:ring-2 focus-within:ring-orange-100 transition-all duration-300 shadow-sm">
      <!-- Search Icon -->
      <div class="flex items-center justify-center pl-4 pr-3">
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>

      <!-- Input -->
      <input type="text" [placeholder]="'Szukaj produktów...' | translate" [attr.aria-label]="'Szukaj produktów' | translate"
        class="flex-1 py-4 pr-4 bg-transparent border-none text-gray-700 placeholder-gray-500 focus:outline-none text-base"
        [formControl]="searchControl" #mobileSearchInput id="mobileSearchInput" autocomplete="off" autocorrect="off"
        autocapitalize="off" spellcheck="false" />

      <!-- Clear Button -->
      <button *ngIf="searchControl.value" type="button" (click)="searchControl.setValue('')"
        class="flex items-center justify-center w-10 h-10 mr-1 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors touch-target"
        [attr.aria-label]="'Wyczyść wyszukiwanie' | translate">
        <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Search Results -->
  <div class="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
    <app-search-results *ngIf="searchControl.value !== ''" [filteredProducts]="filteredProducts"
      [searchQuery]="searchControl.value || ''" (productClick)="onProductClick($event)"
      (viewAllResults)="onViewAllResults($event)" class="px-4 pb-4"></app-search-results>

    <!-- Empty State -->
    <div *ngIf="!searchControl.value" class="flex flex-col items-center justify-center py-12 sm:py-16 px-4 text-center">
      <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-2">{{ 'Wyszukaj produkt' | translate }}</h3>
      <p class="text-sm sm:text-base text-gray-500 max-w-sm leading-relaxed">{{ 'Wpisz nazwę produktu, producenta lub numer katalogowy w polu powyżej.' | translate }}</p>
    </div>
  </div>
</div>

<!-- Country/Currency Selector Sidebar -->
<div class="country-selector-sidebar fixed inset-0 z-[9999]" 
     [class.invisible]="!isCountrySelectorOpen"
     [class.pointer-events-none]="!isCountrySelectorOpen"
     role="dialog"
     aria-modal="true">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black transition-all duration-500 ease-in-out backdrop-blur-sm z-[9998]"
    [style.opacity]="isCountrySelectorOpen ? '0.5' : '0'"
    [style.visibility]="isCountrySelectorOpen ? 'visible' : 'hidden'"
    [style.backdrop-filter]="isCountrySelectorOpen ? 'blur(4px)' : 'blur(0px)'" (click)="closeCountrySelector()"></div>

  <!-- Sidebar -->
  <div
    class="fixed top-0 right-0 h-full w-80 lg:w-96 bg-white shadow-xl flex flex-col transform transition-all duration-500 ease-in-out z-[9999]"
    [class.translate-x-full]="!isCountrySelectorOpen" 
    [class.translate-x-0]="isCountrySelectorOpen"
    [class.opacity-0]="!isCountrySelectorOpen" 
    [class.opacity-100]="isCountrySelectorOpen"
    style="max-width: calc(100vw - 40px); will-change: transform, opacity;" [attr.aria-hidden]="!isCountrySelectorOpen">

    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b bg-orange-50">
      <div class="flex items-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 text-orange-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12h19.5" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 2.25v19.5" />
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3s-4.5 4.03-4.5 9 2.015 9 4.5 9z" />
        </svg>
        <h2 class="text-base font-semibold text-gray-900 notranslate">
          <span *ngIf="currentLanguageCode === 'fr'">{{ 'Sélectionner le pays et la langue' | translate }}</span>
          <span *ngIf="currentLanguageCode === 'pl'">{{ 'Wybierz kraj i język' | translate }}</span>
          <span *ngIf="currentLanguageCode !== 'fr' && currentLanguageCode !== 'pl'">{{ 'Wybierz kraj i język' | translate }}</span>
        </h2>
      </div>
      <button (click)="closeCountrySelector()"
        class="p-2 rounded-full hover:bg-orange-100 transition-colors duration-200" [attr.aria-label]="'Zamknij wybór kraju' | translate">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto p-6">
      <!-- Welcome Message for First-time Visitors -->
      <div *ngIf="!getCookie('brocom_country_visited')"
        class="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 class="text-sm font-semibold text-orange-800">{{ 'Witamy w Brocom!' | translate }}</h3>
        </div>
        <p class="text-sm text-orange-700">{{ 'Wybierz kraj i preferowany język, aby korzystać z lokalnych cen i wygodnych zakupów.' | translate }}</p>
      </div>

      <!-- Language Switcher Section -->
      <div class="mb-6">
        <h3 class="text-sm font-medium text-gray-700 mb-3">{{ 'Język interfejsu' | translate }}</h3>
        <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
          <app-language-switcher></app-language-switcher>
        </div>
      </div>

      <!-- Country Selector Dropdown -->
      <div class="mb-6 relative navbar-country-dropdown-container"
        [class.is-open]="isNavbarCountryDropdownOpen"
        [style.z-index]="isNavbarCountryDropdownOpen ? '1000' : '10'">
        <h3 class="text-sm font-medium text-gray-700 mb-2">{{ 'Wybierz kraj dostawy' | translate }}</h3>

        <!-- Custom Dropdown Trigger Button -->
        <button
          type="button"
          (click)="toggleNavbarCountryDropdown($event)"
          class="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all bg-white flex items-center justify-between cursor-pointer text-left shadow-sm"
          [class.ring-2]="isNavbarCountryDropdownOpen"
          [class.ring-orange-500]="isNavbarCountryDropdownOpen"
          [class.border-transparent]="isNavbarCountryDropdownOpen">
          <div class="flex items-center gap-2.5 min-w-0">
            <span class="text-xl leading-none" *ngIf="selectedCountry?.flag">{{ selectedCountry.flag }}</span>
            <span class="font-medium text-gray-900 truncate">
              {{ selectedCountry ? selectedCountry.name : 'Wybierz kraj...' }}
            </span>
          </div>
          <svg class="w-4 h-4 text-gray-400 transition-transform duration-200 shrink-0 ml-2"
            [class.rotate-180]="isNavbarCountryDropdownOpen"
            [class.text-orange-500]="isNavbarCountryDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Floating Dropdown Menu -->
        <div
          *ngIf="isNavbarCountryDropdownOpen"
          class="absolute z-[9999] left-0 right-0 mt-1.5 bg-white border border-gray-200 rounded-xl shadow-2xl overflow-hidden animate-fadeIn"
          style="background-color: #ffffff !important;"
          (click)="$event.stopPropagation()">
          
          <!-- Sticky Search Header inside dropdown -->
          <div class="p-2 border-b border-gray-100 bg-gray-50" style="background-color: #f9fafb !important;">
            <div class="relative">
              <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                #navbarCountrySearchInput
                type="text"
                [value]="countrySearchTerm"
                (input)="onCountrySearchInput($any($event.target).value)"
                [placeholder]="'Szukaj kraju...' | translate"
                class="w-full pl-9 pr-8 py-2 text-xs sm:text-sm bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-900 placeholder-gray-400"
              />
              <button
                *ngIf="countrySearchTerm"
                type="button"
                (click)="clearCountrySearchTerm($event)"
                class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-0.5"
                [title]="'Wyczyść wyszukiwanie' | translate">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Scrollable Country List -->
          <div class="max-h-56 sm:max-h-60 overflow-y-auto divide-y divide-gray-50 py-1 bg-white" style="background-color: #ffffff !important;">
            <button
              type="button"
              *ngFor="let country of filteredCountries"
              (click)="onSelectCountryOption(country, $event)"
              class="w-full text-left px-3.5 py-2.5 text-xs sm:text-sm flex items-center justify-between transition-colors hover:bg-orange-50 hover:text-orange-600 group cursor-pointer bg-white"
              style="background-color: #ffffff;"
              [class.bg-orange-50]="selectedCountry?.code === country.code"
              [class.text-orange-600]="selectedCountry?.code === country.code"
              [class.font-semibold]="selectedCountry?.code === country.code"
              [class.text-gray-700]="selectedCountry?.code !== country.code">
              <div class="flex items-center gap-2.5 min-w-0">
                <span class="text-lg leading-none shrink-0">{{ country.flag }}</span>
                <span class="truncate">{{ country.name }}</span>
              </div>
              <div class="flex items-center gap-1.5 shrink-0 ml-2">
                <span class="text-[11px] font-mono text-gray-400 group-hover:text-orange-500 uppercase">{{ country.code }}</span>
                <svg *ngIf="selectedCountry?.code === country.code"
                  class="w-4 h-4 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </button>

            <!-- Empty state when no matches -->
            <div *ngIf="filteredCountries.length === 0" class="py-6 px-4 text-center text-xs text-gray-400 bg-white" style="background-color: #ffffff !important;">
              {{ 'Nie znaleziono krajów pasujących do „' | translate }}<span class="font-medium text-gray-600">{{ countrySearchTerm }}</span>”.
            </div>
          </div>
        </div>
      </div>

      <!-- Currency Selector Dropdown (matches Delivery Country Dropdown UI) -->
      <div class="mb-6 relative navbar-currency-dropdown-container"
        [class.is-open]="isNavbarCurrencyDropdownOpen"
        [style.z-index]="isNavbarCurrencyDropdownOpen ? '1000' : '9'">
        <div class="flex items-center justify-between mb-2">
          <h3 class="text-sm font-medium text-gray-700">{{ 'Waluta' | translate }}</h3>
          <span *ngIf="selectedCurrency === 'PLN' && liveExchangeRate" class="text-[11px] text-gray-500 font-medium">
            {{ '1 EUR =' | translate }} {{ liveExchangeRate }} PLN <span class="text-gray-400 font-normal">{{ '(NBP)' | translate }}</span>
          </span>
        </div>

        <!-- Custom Dropdown Trigger Button -->
        <button
          type="button"
          (click)="toggleNavbarCurrencyDropdown($event)"
          class="w-full px-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all bg-white flex items-center justify-between cursor-pointer text-left shadow-sm"
          [class.ring-2]="isNavbarCurrencyDropdownOpen"
          [class.ring-orange-500]="isNavbarCurrencyDropdownOpen"
          [class.border-transparent]="isNavbarCurrencyDropdownOpen">
          <div class="flex items-center gap-3 min-w-0">
            <span translate="no" class="notranslate w-7 h-7 rounded-full bg-orange-50 text-orange-600 border border-orange-100 flex items-center justify-center font-bold text-sm shrink-0">
              {{ selectedCurrency === 'PLN' ? 'zł' : '€' }}
            </span>
            <span translate="no" class="notranslate font-medium text-gray-900 truncate">
              {{ selectedCurrency === 'PLN' ? 'PLN' : 'Euro' }}
            </span>
          </div>
          <svg class="w-4 h-4 text-gray-400 transition-transform duration-200 shrink-0 ml-2"
            [class.rotate-180]="isNavbarCurrencyDropdownOpen"
            [class.text-orange-500]="isNavbarCurrencyDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Floating Currency Dropdown Menu -->
        <div
          *ngIf="isNavbarCurrencyDropdownOpen"
          class="absolute z-[9999] left-0 right-0 mt-1.5 bg-white border border-gray-200 rounded-xl shadow-2xl overflow-hidden animate-fadeIn"
          style="background-color: #ffffff !important;"
          (click)="$event.stopPropagation()">
          <div class="py-1 bg-white divide-y divide-gray-100" style="background-color: #ffffff !important;">
            <!-- Euro Option -->
            <button
              type="button"
              (click)="onSelectCurrencyOption('EUR', $event)"
              class="w-full text-left px-4 py-3 text-xs sm:text-sm flex items-center justify-between transition-colors hover:bg-orange-50 hover:text-orange-600 group cursor-pointer bg-white"
              style="background-color: #ffffff;"
              [class.bg-orange-50]="selectedCurrency === 'EUR'"
              [class.text-orange-600]="selectedCurrency === 'EUR'"
              [class.font-semibold]="selectedCurrency === 'EUR'"
              [class.text-gray-700]="selectedCurrency !== 'EUR'">
              <div class="flex items-center gap-3 min-w-0">
                <span translate="no" class="notranslate w-7 h-7 rounded-full bg-gray-100 group-hover:bg-orange-100 flex items-center justify-center font-bold text-sm shrink-0"
                  [class.text-orange-600]="selectedCurrency === 'EUR'"
                  [class.text-gray-800]="selectedCurrency !== 'EUR'">
                  €
                </span>
                <span translate="no" class="notranslate truncate font-medium">{{ 'euro' | translate }}</span>
              </div>
              <div class="flex items-center gap-2 shrink-0 ml-2">
                <span translate="no" class="notranslate text-[11px] font-mono text-gray-400 group-hover:text-orange-500 uppercase">EUR</span>
                <svg *ngIf="selectedCurrency === 'EUR'"
                  class="w-4 h-4 text-orange-600 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </button>

            <!-- PLN Option -->
            <button
              type="button"
              (click)="onSelectCurrencyOption('PLN', $event)"
              class="w-full text-left px-4 py-3 text-xs sm:text-sm flex items-center justify-between transition-colors hover:bg-orange-50 hover:text-orange-600 group cursor-pointer bg-white"
              style="background-color: #ffffff;"
              [class.bg-orange-50]="selectedCurrency === 'PLN'"
              [class.text-orange-600]="selectedCurrency === 'PLN'"
              [class.font-semibold]="selectedCurrency === 'PLN'"
              [class.text-gray-700]="selectedCurrency !== 'PLN'">
              <div class="flex items-center gap-3 min-w-0">
                <span translate="no" class="notranslate w-7 h-7 rounded-full bg-gray-100 group-hover:bg-orange-100 flex items-center justify-center font-bold text-sm shrink-0"
                  [class.text-orange-600]="selectedCurrency === 'PLN'"
                  [class.text-gray-800]="selectedCurrency !== 'PLN'">
                  {{ 'zł' | translate }}
                </span>
                <span translate="no" class="notranslate truncate font-medium">PLN</span>
              </div>
              <div class="flex items-center gap-2 shrink-0 ml-2">
                <span translate="no" class="notranslate text-[11px] font-mono text-gray-400 group-hover:text-orange-500 uppercase">PLN</span>
                <svg *ngIf="selectedCurrency === 'PLN'"
                  class="w-4 h-4 text-orange-600 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- Selected Country Info -->
      <div *ngIf="selectedCountry" class="mb-6 p-4 bg-gray-50 rounded-lg relative z-0">
        <h4 class="text-sm font-medium text-gray-700 mb-2">{{ 'Wybrany kraj' | translate }}</h4>
        <div class="flex items-center gap-3">
          <span class="text-2xl">{{ selectedCountry.flag }}</span>
          <div class="flex-1">
            <p class="font-medium text-gray-900">{{ selectedCountry.name }}</p>

          </div>
        </div>
      </div>

      <p *ngIf="countrySelectionMessage" class="mb-3 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700" role="status" aria-live="polite">
        {{ countrySelectionMessage }}
      </p>

      <!-- Apply Button -->
      <button (click)="applyCountrySelection()" [disabled]="!selectedCountry"
        class="w-full bg-orange-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center">
        {{ 'Zastosuj wybór' | translate }}
      </button>
    </div>
  </div>
</div>

<app-cart-dropdown [isOpen]="isCartOpen" [isClosing]="isCartClosing" (close)="closeCart()" class="transition-smooth"></app-cart-dropdown>